import React from 'react';
import ReactDOM from 'react-dom';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { estados } from '../../util/estados';
import './EmpresaForm.css';

const CHECK_ICON = '<svg viewBox="0 0 24 24" width="38" height="38" aria-hidden="true">'
    + '<path fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7.5"/>'
    + '</svg>';

const SYNC_MODAL = {
    icon: 'question',
    iconHtml: CHECK_ICON,
    width: '26em',
    customClass: { popup: 'ef-swal', icon: 'ef-swal-icon' },
};

class EmpresaForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            owner: '',
            owner_email: '',
            cnpj: '',
            cellphone: '',
            status: 1,
            default_role_ids: [],
            roles_options: [],
            city_ids: [],
            selected_states: [],
            cities_options: [],
            linked_users_count: 0,
            errors: {},
            loading: false,
        };
        this.handleSubmit       = this.handleSubmit.bind(this);
        this.handleSyncUsers    = this.handleSyncUsers.bind(this);
        this.handleStatesChange = this.handleStatesChange.bind(this);
        this.handleCellphoneChange = this.handleCellphoneChange.bind(this);
    }

    handleCellphoneChange(e) {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 11);
        let masked = digits;

        if (digits.length > 10) {
            masked = digits.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3');
        } else if (digits.length > 6) {
            masked = digits.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
        } else if (digits.length > 2) {
            masked = digits.replace(/^(\d{2})(\d+)/, '($1) $2');
        } else if (digits.length > 0) {
            masked = digits.replace(/^(\d+)/, '($1');
        }

        this.setState({ cellphone: masked });
    }

    // Retorna os UFs únicos das cidades selecionadas com base em cities_options
    deriveStatesFromCities(cityIds, citiesOptions) {
        const map = {};
        citiesOptions.forEach(group => {
            group.items.forEach(city => { map[city.value] = group.label; });
        });
        return [...new Set((cityIds || []).map(id => map[id]).filter(Boolean))];
    }

    updateNavbarBrand() {
        const navbarBrand = document.querySelector('#layout_top_bar .navbar-brand');
        const companyName = window.__EMPRESA_NAME__;
        if (!navbarBrand || !companyName) {
            return;
        }

        const title = document.createElement('a');
        title.href = route('empresa.index');
        title.className = 'empresa-titulo';
        title.textContent = 'Editar Empresa';

        const current = document.createElement('span');
        current.className = 'empresa-nome';
        current.textContent = `› ${companyName}`;

        const wrapper = document.createElement('span');
        wrapper.className = navbarBrand.className;
        wrapper.append(title, ' ', current);
        navbarBrand.replaceWith(wrapper);
    }

    componentDidMount() {

        const isEdit = route().current() === 'empresa.edit';

        if (isEdit) {
            this.updateNavbarBrand();
        }

        const citiesPromise = axios.get('/cidades/for-select').then(r => r.data);

        axios.get('/role-json').then(r => {
            this.setState({ roles_options: r.data.roles });
        });

        const empresaId = route().params?.empresa;

        if (isEdit && empresaId) {
            this.setState({ loading: true });

            Promise.all([citiesPromise, axios.get(`/empresas-crud/${empresaId}`)])
                .then(([citiesOptions, companyRes]) => {
                    const { name, owner, owner_email, cnpj, cellphone, city_ids, default_role_ids, status, linked_users_count } = companyRes.data;
                    this.setState({
                        cities_options:   citiesOptions,
                        name:             name || '',
                        owner:            owner || '',
                        owner_email:      owner_email || '',
                        cnpj:             cnpj || '',
                        cellphone:        cellphone || '',
                        status:           status !== undefined ? status : 1,
                        default_role_ids: default_role_ids || [],
                        city_ids:         city_ids || [],
                        linked_users_count: linked_users_count || 0,
                        selected_states:  this.deriveStatesFromCities(city_ids, citiesOptions),
                        loading:          false,
                    });
                })
                .catch(() => this.setState({ loading: false }));
        } else {
            citiesPromise.then(citiesOptions => this.setState({ cities_options: citiesOptions }));
        }
    }

    handleStatesChange(e) {
        const newStates = e.value;
        const { cities_options, city_ids } = this.state;

        const validIds = new Set();
        cities_options
            .filter(g => newStates.includes(g.label))
            .forEach(g => g.items.forEach(c => validIds.add(c.value)));

        this.setState({
            selected_states: newStates,
            city_ids: city_ids.filter(id => validIds.has(id)),
        });
    }

    saveCompany(syncUsers = false) {
        const { name, owner, owner_email, cnpj, cellphone, status, default_role_ids, city_ids } = this.state;
        const isEdit = route().current() === 'empresa.edit';
        const empresaId = route().params?.empresa;

        const url    = isEdit ? `/empresas-crud/${empresaId}` : '/empresas-crud';
        const method = isEdit ? 'put' : 'post';

        const payload = { name, owner, owner_email, cnpj, cellphone, status, default_role_ids, city_ids };
        if (syncUsers) {
            payload.sync_users = true;
        }

        this.setState({ loading: true, errors: {} });

        return axios[method](url, payload)
            .catch(error => {
                if (error.response && error.response.status === 422) {
                    this.setState({ errors: error.response.data.errors, loading: false });
                } else {
                    this.setState({ loading: false });
                }
                throw error;
            });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.saveCompany()
            .then(response => {
                window.location.href = response.data.redirect;
            })
            .catch(() => {});
    }

    handleSyncUsers() {
        const { linked_users_count } = this.state;

        if (linked_users_count === 0) {
            Swal.fire({
                icon: 'info',
                title: 'Esta empresa não possui usuários vinculados.',
                confirmButtonColor: '#00763B',
                confirmButtonText: 'Fechar',
            });
            return;
        }

        const plural = linked_users_count === 1 ? 'usuário' : 'usuários';
        const verb   = linked_users_count === 1 ? 'Será atualizado' : 'Serão atualizados';

        Swal.fire({
            ...SYNC_MODAL,
            html: `${verb} ${linked_users_count} ${plural} com as configurações atuais da empresa. Deseja continuar?`,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
        }).then(result => {
            if (!result.value) {
                return;
            }

            this.saveCompany(true)
                .then(response => {
                    const synced = response.data.synced_users || 0;
                    const label  = synced === 1 ? 'usuário sincronizado' : 'usuários sincronizados';

                    return Swal.fire({
                        ...SYNC_MODAL,
                        html: `Empresa atualizada.<br>${synced} ${label} com sucesso.`,
                        confirmButtonText: 'Fechar',
                    }).then(() => {
                        window.location.href = response.data.redirect;
                    });
                })
                .catch(() => {});
        });
    }

    render() {
        const {
            name, owner, owner_email, cnpj, cellphone,
            status, default_role_ids, roles_options,
            city_ids, selected_states, cities_options,
            errors, loading,
        } = this.state;

        const STATUS_OPTIONS = [
            { label: 'Ativa',                           value: 1 },
            { label: 'Suspensa',                        value: 0 },
            { label: 'Suspensa por Falta de Pagamento', value: 2 },
        ];

        const isEdit = window.__EMPRESA_ACTION__ === 'edit';
        const submitLabel = isEdit ? 'Atualizar Empresa' : 'Criar Empresa';

        if (loading && isEdit && !name) {
            return (
                <div className="empresa-form">
                    <div className="ef-loading">
                        <i className="fa fa-spinner fa-spin"></i> Carregando...
                    </div>
                </div>
            );
        }

        const filtered_cities = selected_states.length
            ? cities_options
                .filter(g => selected_states.includes(g.label))
                .flatMap(g => g.items)
            : [];

        return (
            <form className="empresa-form" onSubmit={this.handleSubmit}>
                <div className="ef-actions">
                    <button
                        type="submit"
                        className={`ef-btn ${isEdit ? 'ef-btn--outline' : 'ef-btn--primary'}`}
                        disabled={loading}
                    >
                        {loading
                            ? <><i className="fa fa-spinner fa-spin"></i> Aguarde...</>
                            : <><i className={`fa ${isEdit ? 'fa-edit' : 'fa-plus'}`}></i> {submitLabel}</>}
                    </button>
                    {isEdit && (
                        <button
                            type="button"
                            className="ef-btn ef-btn--primary"
                            disabled={loading}
                            onClick={this.handleSyncUsers}
                        >
                            <i className="fa fa-users"></i> Atualizar Usuários Vinculados
                        </button>
                    )}
                </div>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12">
                            <label className={`ef-label${errors.name ? ' ef-label--error' : ''}`}>Nome*</label>
                            <InputText
                                className={`d-block w-100 input-disabled${errors.name ? ' ef-invalid' : ''}`}
                                name="name"
                                value={name}
                                onChange={e => this.setState({ name: e.target.value })}
                                placeholder="Nome"
                            />
                            {errors.name && <div className="ef-error">{errors.name[0]}</div>}
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-6">
                            <label className={`ef-label${errors.owner ? ' ef-label--error' : ''}`}>Responsável*</label>
                            <InputText
                                className={`d-block w-100 input-disabled${errors.owner ? ' ef-invalid' : ''}`}
                                name="owner"
                                value={owner}
                                onChange={e => this.setState({ owner: e.target.value })}
                                placeholder="Responsável"
                            />
                            {errors.owner && <div className="ef-error">{errors.owner[0]}</div>}
                        </div>
                        <div className="col-6">
                            <label className={`ef-label${errors.owner_email ? ' ef-label--error' : ''}`}>Email responsável*</label>
                            <InputText
                                className={`d-block w-100 input-disabled${errors.owner_email ? ' ef-invalid' : ''}`}
                                name="owner_email"
                                value={owner_email}
                                onChange={e => this.setState({ owner_email: e.target.value })}
                                placeholder="Email responsável"
                            />
                            {errors.owner_email && <div className="ef-error">{errors.owner_email[0]}</div>}
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-6">
                            <label className="ef-label">CNPJ</label>
                            <InputMask
                                className="d-block w-100 input-disabled"
                                name="cnpj"
                                value={cnpj}
                                onChange={e => this.setState({ cnpj: e.value })}
                                mask="99.999.999/9999-99"
                                placeholder="CNPJ"
                            />
                            {errors.cnpj && <div className="ef-error">{errors.cnpj[0]}</div>}
                        </div>
                        <div className="col-6">
                            <label className="ef-label">Contato</label>
                            <input
                                className="d-block w-100 p-inputtext input-disabled"
                                name="cellphone"
                                value={cellphone}
                                onChange={this.handleCellphoneChange}
                                placeholder="(00) 0000-0000 ou (00) 00000-0000"
                                maxLength={16}
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group">
                        <label className="ef-label">Perfil padrão dos usuários</label>
                        <MultiSelect
                            value={default_role_ids}
                            options={roles_options}
                            optionLabel="label"
                            optionValue="value"
                            onChange={e => this.setState({ default_role_ids: e.value })}
                            placeholder="Selecione os perfis padrão"
                            filter
                            filterPlaceholder="Buscar perfil..."
                            display="chip"
                            className="w-100"
                        />
                    </div>
                </fieldset>

                {isEdit && (
                    <fieldset>
                        <div className="form-group">
                            <label className="ef-label">Status da Empresa</label>
                            <Dropdown
                                value={status}
                                options={STATUS_OPTIONS}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ status: e.value })}
                                className="w-100"
                            />
                        </div>
                    </fieldset>
                )}

                <fieldset>
                    <div className="form-group row">
                        <div className="col-6">
                            <label className="ef-label">Estados</label>
                            <MultiSelect
                                value={selected_states}
                                options={estados}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.handleStatesChange}
                                placeholder="Selecione os estados"
                                filter
                                filterPlaceholder="Buscar estado..."
                                display="chip"
                                className="w-100"
                            />
                        </div>
                        <div className="col-6">
                            <label className="ef-label">Cidades</label>
                            <MultiSelect
                                value={city_ids}
                                options={filtered_cities}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ city_ids: e.value })}
                                placeholder={selected_states.length ? 'Selecione as cidades' : 'Selecione um estado primeiro'}
                                disabled={!selected_states.length}
                                filter
                                filterPlaceholder="Buscar cidade..."
                                display="chip"
                                className="w-100"
                            />
                        </div>
                    </div>
                </fieldset>
            </form>
        );
    }
}

const mountPoint = document.getElementById('js-empresa-form');
if (mountPoint) {
    ReactDOM.render(<EmpresaForm />, mountPoint);
}
